module.exports = __webpack_public_path__ + "static/03-4a3fbf5a8cd53d2f1390183937d8b2c4.svg";